export default "__VITE_ASSET__D7BXNrSS__"